export default "__VITE_ASSET__BWdZDuNN__"